export const DATA_GRID_EVENTS = {
    escapeKeyDown: 'escapeKeyDown',
    enterKeyDown: 'enterKeyDown',
    rowFocusOut: 'rowFocusOut'
};

export const ROW_FOCUS_OUT_EDIT_ACTIONS = {
    suppress: 'suppress',
    cancelClean: 'cancelClean',
    commit: 'commit'
} as const;
